<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>首页轮播图信息</span>
      <div>
        <el-button v-if="$hasPermission('mall:carousel:save')" type="primary" size="mini" @click="openCreate">新增轮播图</el-button>
      </div>
    </div>

    <div class="search-bar search-wrap">
      <el-input v-model.trim="query.title" placeholder="请输入标题" clearable style="width: 260px" @keyup.enter.native="handleSearch" />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="title" label="标题" min-width="160" />
      <el-table-column label="预览图" width="110">
        <template slot-scope="{ row }">
          <el-image
            :src="resolveFileUrl(row.imageUrl)"
            :preview-src-list="row.imageUrl ? [resolveFileUrl(row.imageUrl)] : []"
            fit="cover"
            class="table-image"
          >
            <div slot="error" class="table-image-error">无图</div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="imageUrl" label="图片地址" min-width="240" show-overflow-tooltip />
      <el-table-column prop="linkType" label="跳转类型" width="120">
        <template slot-scope="{ row }">
          {{ linkTypeText(row.linkType) }}
        </template>
      </el-table-column>
      <el-table-column prop="linkValue" label="跳转值" min-width="180" show-overflow-tooltip />
      <el-table-column prop="sortNum" label="排序" width="90" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">
          {{ row.status === 1 ? '启用' : '禁用' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-if="$hasPermission('mall:carousel:update')" size="mini" @click="openEdit(row)">编辑</el-button>
          <el-button
            v-if="$hasPermission('mall:carousel:update')"
            :type="row.status === 1 ? 'warning' : 'success'"
            size="mini"
            @click="toggleStatus(row)"
          >
            {{ row.status === 1 ? '禁用' : '启用' }}
          </el-button>
          <el-button v-if="$hasPermission('mall:carousel:delete')" size="mini" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="form.id ? '编辑轮播图' : '新增轮播图'" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="标题">
          <el-input v-model.trim="form.title" />
        </el-form-item>
        <el-form-item label="图片信息" prop="imageUrl">
          <image-selector
            v-model="form.imageUrl"
            :category-code.sync="form.imageCategoryCode"
            :allowed-categories="['carousel']"
          />
        </el-form-item>
        <el-form-item label="跳转类型">
          <el-select v-model="form.linkType" style="width: 100%" @change="handleLinkTypeChange">
            <el-option :value="0" label="无跳转" />
            <el-option :value="1" label="商品" />
            <el-option :value="2" label="分类" />
            <el-option :value="3" label="页面" />
            <el-option :value="4" label="外链" />
            <el-option :value="5" label="其他小程序" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.linkType === 5" label="小程序AppId">
          <el-input v-model.trim="form.miniProgramAppId" placeholder="请输入目标小程序AppId，如 wx1234567890abcdef" />
        </el-form-item>
        <el-form-item v-if="form.linkType === 5" label="跳转路径">
          <el-input v-model.trim="form.miniProgramPath" placeholder="可为空，示例：pages/index/index?id=1" />
        </el-form-item>
        <el-form-item v-if="form.linkType === 5" label="版本环境">
          <el-select v-model="form.miniProgramEnvVersion" style="width: 100%">
            <el-option label="正式版" value="release" />
            <el-option label="体验版" value="trial" />
          </el-select>
        </el-form-item>
        <el-form-item v-else label="跳转值">
          <el-input v-model.trim="form.linkValue" :placeholder="linkValuePlaceholder" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model.number="form.sortNum" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission(form.id ? 'mall:carousel:update' : 'mall:carousel:save')"
          type="primary"
          @click="save"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'
import { resolveFileUrl } from '../../utils/file'
import ImageSelector from '../../components/mall/ImageSelector.vue'

function defaultForm () {
  return {
    id: null,
    title: '',
    imageUrl: '',
    imageCategoryCode: 'carousel',
    linkType: 0,
    linkValue: '',
    miniProgramAppId: '',
    miniProgramPath: '',
    miniProgramEnvVersion: 'release',
    sortNum: 0,
    status: 1
  }
}

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    title: ''
  }
}

export default {
  components: {
    ImageSelector
  },
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        imageUrl: [{ required: true, message: '请选择轮播图', trigger: 'change' }]
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    resolveFileUrl,
    async load () {
      const { data } = await http.get('/mall/carousel/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    linkTypeText (value) {
      const map = { 0: '无跳转', 1: '商品', 2: '分类', 3: '页面', 4: '外链', 5: '其他小程序' }
      return map[value] || '无跳转'
    },
    handleLinkTypeChange () {
      if (this.form.linkType !== 5) {
        this.form.miniProgramAppId = ''
        this.form.miniProgramPath = ''
        this.form.miniProgramEnvVersion = 'release'
      }
      if (this.form.linkType === 0) {
        this.form.linkValue = ''
      }
    },
    parseMiniProgramValue (value) {
      const raw = String(value || '').trim()
      if (!raw) {
        return { appId: '', path: '' }
      }
      if (raw.startsWith('{')) {
        try {
          const data = JSON.parse(raw)
          return {
            appId: String(data.appId || '').trim(),
            path: String(data.path || '').trim(),
            envVersion: this.normalizeMiniProgramEnv(data.envVersion)
          }
        } catch (e) {}
      }
      const parts = raw.split('|')
      return {
        appId: String(parts[0] || '').trim(),
        path: String(parts[1] || '').trim(),
        envVersion: this.normalizeMiniProgramEnv(parts[2])
      }
    },
    normalizeMiniProgramEnv (value) {
      const envVersion = String(value || '').trim()
      return ['release', 'trial'].indexOf(envVersion) === -1 ? 'release' : envVersion
    },
    buildMiniProgramValue () {
      const appId = String(this.form.miniProgramAppId || '').trim()
      const path = String(this.form.miniProgramPath || '').trim()
      const envVersion = this.normalizeMiniProgramEnv(this.form.miniProgramEnvVersion)
      return `${appId}|${path}|${envVersion}`
    },
    validateLink () {
      if (this.form.linkType === 0) {
        return true
      }
      if (this.form.linkType === 5) {
        if (!this.form.miniProgramAppId) {
          this.$message.warning('请输入目标小程序AppId')
          return false
        }
        if (!/^wx[a-zA-Z0-9]{16}$/.test(this.form.miniProgramAppId)) {
          this.$message.warning('小程序AppId格式不正确')
          return false
        }
        return true
      }
      if (!String(this.form.linkValue || '').trim()) {
        this.$message.warning('请输入跳转值')
        return false
      }
      return true
    },
    openCreate () {
      this.form = defaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    async openEdit (row) {
      const { data } = await http.get(`/mall/carousel/info/${row.id}`)
      const info = data.data || {}
      const miniProgram = this.parseMiniProgramValue(info.linkValue)
      this.form = {
        id: info.id,
        title: info.title || '',
        imageUrl: info.imageUrl || '',
        imageCategoryCode: 'carousel',
        linkType: info.linkType == null ? 0 : info.linkType,
        linkValue: info.linkType === 5 ? '' : (info.linkValue || ''),
        miniProgramAppId: info.linkType === 5 ? miniProgram.appId : '',
        miniProgramPath: info.linkType === 5 ? miniProgram.path : '',
        miniProgramEnvVersion: info.linkType === 5 ? miniProgram.envVersion : 'release',
        sortNum: info.sortNum || 0,
        status: info.status
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    toggleStatus (row) {
      const nextStatus = row.status === 1 ? 0 : 1
      const actionText = nextStatus === 1 ? '启用' : '禁用'
      this.$confirm(`确定${actionText}轮播图“${row.title || '未命名'}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/carousel/status', {
          id: row.id,
          status: nextStatus
        })
        if (data.code === 0) {
          this.$message.success(`轮播图${actionText}成功`)
          this.load()
        }
      })
    },
    save () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (!this.validateLink()) return
        const payload = {
          id: this.form.id,
          title: this.form.title,
          imageUrl: this.form.imageUrl,
          linkType: this.form.linkType,
          linkValue: this.form.linkType === 5 ? this.buildMiniProgramValue() : this.form.linkValue,
          sortNum: this.form.sortNum,
          status: this.form.status
        }
        const url = payload.id ? '/mall/carousel/update' : '/mall/carousel/save'
        const { data } = await http.post(url, payload)
        if (data.code === 0) {
          this.$message.success(payload.id ? '轮播图修改成功' : '轮播图新增成功')
          this.dialogVisible = false
          this.load()
        }
      })
    },
    remove (row) {
      this.$confirm('确定删除该轮播图吗？', '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/carousel/delete', [row.id])
        if (data.code === 0) {
          this.$message.success('轮播图删除成功')
          this.load()
        }
      })
    }
  },
  computed: {
    linkValuePlaceholder () {
      const map = {
        0: '无跳转时可留空',
        1: '请输入商品ID',
        2: '分类跳转可留空，当前会跳转到分类页',
        3: '请输入小程序内部页面路径，如 /pages/goods/index?id=1',
        4: '请输入外链地址，如 https://example.com'
      }
      return map[this.form.linkType] || '请输入跳转值'
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.table-image {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  cursor: pointer;
}

.table-image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #f5f7fa;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
